import { MotsIgnoresState } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getMotsIgnores } from '@/services/api/motifs/api';
import _ from 'lodash';

const namespaced: boolean = true;

export const state: MotsIgnoresState = {
	motsIgnores: [],
	error: false,
	loaded: false
};

export const mutations: MutationTree<MotsIgnoresState> = {
	updateMotsIgnores(state: MotsIgnoresState, motsIgnores: string[]): void {
		state.motsIgnores = motsIgnores;
	},
	updateError(state: MotsIgnoresState, error: boolean): void {
		state.error = error;
	},
	updateLoaded(state: MotsIgnoresState, loaded: boolean): void {
		state.loaded = loaded;
	}
};

export const actions: ActionTree<MotsIgnoresState, RootState> = {
	fetchMotsIgnores(state): Promise<void> {
		return new Promise((resolve, reject) => {
			return getMotsIgnores()
				.then((response: any) => {
					state.commit('updateMotsIgnores', _.get(response, 'data.value.listeMots'));
					state.commit('updateLoaded', true);
					resolve();
				})
				.catch((error: any) => {
					state.commit('updateLoaded', true);
					state.commit('updateError', true);
					reject();
				});
		});
	}
};

export const getters: GetterTree<MotsIgnoresState, RootState> = {
	getMotsIgnores(state) {
		return state.motsIgnores;
	},
	getError(state) {
		return state.error;
	},
	getLoaded(state) {
		return state.loaded;
	}
};

export const motsIgnores: Module<MotsIgnoresState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
